import { tokenResolutionApi } from '@/services/api/tokenResolution'
import { templateTrainingApi } from '@/services/api/templateTraining'
import type { PdfPageResponse } from '@/types/tokenResolution'

export async function loadTokenPdf(opts: {
  token?: string
  sessionId?: string
  templateId?: string
  sourceSessionId?: string
}): Promise<PdfPageResponse | null> {
  const source = opts.sourceSessionId || opts.sessionId
  if (source) {
    return tokenResolutionApi.getSessionPdfPage(source, undefined, opts.token)
  }
  if (opts.templateId) {
    return templateTrainingApi.getTemplatePdfPage(opts.templateId, undefined, {
      token: opts.token,
      sessionId: opts.sourceSessionId,
    })
  }
  return null
}
